import { render, staticRenderFns } from "./presIva.vue?vue&type=template&id=d2caf03a"
import script from "./presIva.vue?vue&type=script&lang=js"
export * from "./presIva.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports